export const mediaQueryMobileLimit = 900

